import React from "react";

export default function Watermark({ name, idNumber }) {
  const text = `${name} - ${idNumber}`;

  const watermarkStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: 99,
    overflow: "hidden",
    userSelect: "none",
  };

  const items = [];

  for (let row = -2; row < 20; row++) {
    for (let col = -1; col < 6; col++) {
      items.push(
        <div
          key={`${row}-${col}`}
          style={{
            position: "absolute",
            top: `${row * 120}px`,
            left: `${col * 280}px`,
            transform: "rotate(-35deg)",
            fontSize: 16,
            fontWeight: "600",
            color: "rgba(0, 0, 0, 0.12)",
            whiteSpace: "nowrap",
            letterSpacing: 1,
          }}
        >
          {text}
        </div>,
      );
    }
  }

  return <div style={watermarkStyle}>{items}</div>;
}
